import { PearBox } from '@dealstack/frontend/shared/components/PearBox/PearBox';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationUserProfiles } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Navigate, Route, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Text } from '@mantine/core';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { BankingDetails } from '@dealstack/frontend/shared/components/BankingDetails/BankingDetails';
import { AccountSettings } from '@dealstack/frontend/shared/components/AccountSettings/AccountSettings';
import { ProfileSidebarMenu } from '@dealstack/frontend/shared/components/Profile/ProfileSidebarMenu';
import { PIVDetails } from '@dealstack/frontend/shared/components/Profile/PIVDetails/PIVDetails';
import { PersonalDetails } from '@dealstack/frontend/shared/components/Profile/PersonalDetails/PersonalDetails';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry';

interface Props {
	className?: string;
	dashboardRoute: string;
	userProfileRoute: string;
}

export const enum PROFILE_ROUTES {
	PERSONAL_DETAILS = '/personal-details',
	BANKING_DETAILS = '/banking-details',
	ACCOUNT_SETTINGS = '/account-settings',
	PIV_DETAILS = '/piv-details',
}

const ProfilePage = ({ className, dashboardRoute, userProfileRoute }: Props) => {
	const navigate = useNavigate();
	const location = useLocation();
	const tUserProfiles = useTranslationUserProfiles();

	const getHeaderText = () => {
		return location.pathname.includes(PROFILE_ROUTES.PIV_DETAILS)
			? tUserProfiles('piv.section_name')
			: tUserProfiles('account_management.title');
	};

	return (
		<div className={className}>
			<HeaderWrapper>
				<Icon size="xxl" variant="arrow-left-v3" onClick={() => navigate(dashboardRoute)} />

				<Text size="B4Bold" c={defaultTheme.v2.color.secondary[800]}>
					{getHeaderText()}
				</Text>
			</HeaderWrapper>
			<ContentAndSidebarWrapper>
				<ProfileSidebarMenu />
				<TabsContent>
					<SentryRoutes>
						<Route
							path={PROFILE_ROUTES.PERSONAL_DETAILS}
							element={<PersonalDetails />}
						/>
						<Route path={PROFILE_ROUTES.BANKING_DETAILS} element={<BankingDetails />} />
						<Route
							path={PROFILE_ROUTES.ACCOUNT_SETTINGS}
							element={<AccountSettings />}
						/>
						<Route path={PROFILE_ROUTES.PIV_DETAILS} element={<PIVDetails />} />
						<Route
							path="*"
							element={
								<Navigate
									to={`${userProfileRoute}${PROFILE_ROUTES.PERSONAL_DETAILS}`}
								/>
							}
						/>
					</SentryRoutes>
				</TabsContent>
			</ContentAndSidebarWrapper>
		</div>
	);
};
const HeaderWrapper = styled.div`
	display: grid;
	grid-template-columns: 15rem auto;
	gap: 1em;
	${Icon} {
		color: ${({ theme }) => theme.v2.color.secondary[800]};
	}
`;
const TabsContent = styled.div``;

const ContentAndSidebarWrapper = styled.div`
	display: grid;
	grid-template-columns: 15rem auto;
	gap: 1em;
`;
const Styled = styled(ProfilePage)`
	margin: 2rem;

	${PearBox} {
		margin-bottom: 0.5rem;
	}
	${ContentAndSidebarWrapper} {
		margin-top: 2rem;
	}
`;

export { Styled as Profile };
